import React from "react";
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import HelperAnalyticsEvent from "src/support/HelperAnalyticsEvent";

const SItePage = (props) => {
  const { sitePageList, searchText, tab } = props;

  const typeHeadSearchEvent = (obj) => {
    HelperAnalyticsEvent.typeHeadSearchEvent(searchText, 'Site Pages', obj?.name, obj?.url)
  }
  return (
    <>
      <div className="search-item-title text-uppercase">RECOMMENDED SITE PAGES</div>
      {Object.keys(sitePageList).length > 0 && (
        <>
          <div className="search-artical-list">
            {Object.keys(sitePageList).length > 0 &&
              Object.entries(sitePageList).map((v, i) => (
                <React.Fragment key={i}>
                  {i < 5 && (
                    <div className="search-artical-list-item">
                      <div className="search-artical-list-item-info">
                        <a
                         onClick={() => typeHeadSearchEvent(v[1])}
                         href={v[1]?.url}
                          className=" cursor-pointer"
                        >
                          <div className="search-artical-title">{v[1].name}</div>
                        </a>
                        <div className="search-artical-desc">
                          {v[1].shortDescription}
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
          </div>
          <a
            href={
              HomePage.makeHomeTabsListRouteURL(tab) + "&__c_HomePageContent=ALCT&__c_HomePageContentTabList=SITE&search=" + searchText }
            className="text-center mt-auto pb-3 pt-3"
          >
            <div className="bs5 btn btn-sm btn-primary">VIEW ALL SITE PAGE RESULTS</div>
          </a>
        </>
      )}
      {Object.keys(sitePageList).length === 0 && (
        <>
          <NoContent />
        </>
      )}
    </>
  );
};

export default SItePage;
